import script from "./DeveloperWhiteList.vue?vue&type=script&setup=true&lang=js"
export * from "./DeveloperWhiteList.vue?vue&type=script&setup=true&lang=js"

import "./DeveloperWhiteList.vue?vue&type=style&index=0&id=671c31de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-671c31de"]])

export default __exports__